import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f8ebb762"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-edit-modal--supporter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = { class: "form-grid" }
const _hoisted_5 = { class: "form-grid__logo" }
const _hoisted_6 = { class: "avatar-section" }
const _hoisted_7 = { class: "avatar-section__actions" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "form-grid__left-fields" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-question" }, null, -1))
const _hoisted_12 = { class: "form-grid__right-fields" }
const _hoisted_13 = { class: "form-grid form-grid--centered" }
const _hoisted_14 = { class: "form-grid__left-fields" }
const _hoisted_15 = { class: "form-grid__right-fields" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTabPane = _resolveComponent("ElTabPane")!
  const _component_ElTabs = _resolveComponent("ElTabs")!
  const _component_PxAvatar = _resolveComponent("PxAvatar")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_ElUpload = _resolveComponent("ElUpload")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_ElCheckbox = _resolveComponent("ElCheckbox")!
  const _component_ElCheckboxGroup = _resolveComponent("ElCheckboxGroup")!
  const _component_PxInputPlaces = _resolveComponent("PxInputPlaces")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_PxTextarea = _resolveComponent("PxTextarea")!
  const _component_MultiSelector = _resolveComponent("MultiSelector")!
  const _component_ElRadio = _resolveComponent("ElRadio")!
  const _component_PxRadioGroup = _resolveComponent("PxRadioGroup")!
  const _component_ElForm = _resolveComponent("ElForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElTabs, {
      modelValue: _ctx.currentView,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentView) = $event)),
      class: "el-tabs--blue-line"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElTabPane, {
          label: _ctx.$t('profile.companyEditModal.tabs.general'),
          name: "general"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_ElTabPane, {
          label: _ctx.$t('profile.companyEditModal.tabs.interests'),
          name: "interests"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ElForm, {
      ref: "form",
      model: _ctx.form.data,
      rules: _ctx.rules,
      onValidate: _ctx.updateSubmitState
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ElUpload, {
                ref: "upload",
                "auto-upload": false,
                "on-change": _ctx.onFileChange,
                "show-file-list": false,
                accept: "image/png, image/jpeg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PxAvatar, {
                    name: _ctx.form.data.company.name,
                    photo: _ctx.avatarUrl
                  }, null, 8, ["name", "photo"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_PxButton, {
                      class: _normalizeClass(_ctx.classesAvatarBtn),
                      type: _ctx.typeAvatarBtn,
                      icon: "camera",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("profile.companyEditModal.logo.button")), 1)
                      ]),
                      _: 1
                    }, 8, ["class", "type"]),
                    _createElementVNode("p", {
                      class: "avatar-section__text",
                      innerHTML: _ctx.$t('profile.companyEditModal.logo.help')
                    }, null, 8, _hoisted_8)
                  ])
                ]),
                _: 1
              }, 8, ["on-change"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ElFormItem, {
              label: 
              _ctx.$t(`profile.companyEditModal.fields.name[${_ctx.$profile.type()}]`)
            ,
              prop: "company.name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElInput, {
                  modelValue: _ctx.form.data.company.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.data.company.name) = $event)),
                  placeholder: 
                _ctx.$t(`profile.companyEditModal.fields.name[${_ctx.$profile.type()}]`)
              
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('profile.companyEditModal.fields.email'),
              prop: "company.email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElInput, {
                  ref: "email",
                  modelValue: _ctx.form.data.company.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.data.company.email) = $event)),
                  placeholder: _ctx.$t('profile.companyEditModal.fields.email')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('supporters.signup.form.fields.supporterType'),
              class: "el-form-item--types",
              prop: "supporter.types"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElCheckboxGroup, {
                  modelValue: _ctx.selectedTypes,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTypes) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTypes, (type, key) => {
                      return (_openBlock(), _createBlock(_component_ElCheckbox, {
                        key: key,
                        value: type.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.name) + " ", 1),
                          (type.label)
                            ? (_openBlock(), _createBlock(_component_ElTooltip, {
                                key: 0,
                                placement: "top",
                                "popper-class": "auth-signup__tooltip el-abaca-tooltip"
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", {
                                    innerHTML: type.label
                                  }, null, 8, _hoisted_10)
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128)),
                    _createVNode(_component_ElCheckbox, {
                      value: "",
                      onChange: _cache[3] || (_cache[3] = (value) => _ctx.otherTypeChangeHandler(value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("supporters.signup.form.fields.otherSupporterType")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _withDirectives(_createVNode(_component_ElInput, {
                  modelValue: _ctx.form.data.supporter.otherType,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.data.supporter.otherType) = $event)),
                  placeholder: 
                _ctx.$t('supporters.signup.form.placeholders.supporterType')
              ,
                  class: "other-type-input"
                }, null, 8, ["modelValue", "placeholder"]), [
                  [_vShow, _ctx.hasOtherType]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('profile.companyEditModal.fields.location'),
              prop: "company.locations"
            }, {
              default: _withCtx(() => [
                (_ctx.form.data.company.locations)
                  ? (_openBlock(), _createBlock(_component_PxInputPlaces, {
                      key: 0,
                      id: "companyEditLocation",
                      modelValue: _ctx.form.data.company.locations[0],
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.data.company.locations[0]) = $event)),
                      placeholder: _ctx.$t('profile.companyEditModal.fields.location'),
                      "use-geolocation": true
                    }, null, 8, ["modelValue", "placeholder"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('profile.companyEditModal.fields.website'),
              prop: "company.website"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElInput, {
                  ref: "website",
                  modelValue: _ctx.form.data.company.website,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.data.company.website) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: 
                _ctx.$t('authentication.signup.form.fields.websitePlaceholder')
              
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_PxIcon, {
                      size: 24,
                      name: "website"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('profile.companyEditModal.fields.about'),
              prop: "company.about"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PxTextarea, {
                  ref: "about",
                  modelValue: _ctx.form.data.company.about,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.data.company.about) = $event)),
                  "max-chars": _ctx.rules['company.about'].max,
                  placeholder: _ctx.$t('profile.companyEditModal.placeholders.about'),
                  "show-counter": ""
                }, null, 8, ["modelValue", "max-chars", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ], 512), [
          [_vShow, _ctx.currentView === 'general']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ElFormItem, { prop: "supporter.sectors" }, {
              default: _withCtx(() => [
                _createVNode(_component_MultiSelector, {
                  modelValue: _ctx.form.data.supporter.sectors,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.data.supporter.sectors) = $event)),
                  "fetch-on-created": true,
                  "needs-refresh": _ctx.resetForm,
                  "remote-method": _ctx.searchSectors,
                  "subtext-label-list": [
                'common.components.multiSelector.sectors.subLabel',
                'common.components.multiSelector.sectors.subLabelPlural',
              ],
                  label: "supporters.signup.form.fields.sector",
                  placeholder: "supporters.signup.form.placeholders.sector",
                  tip: "supporters.signup.form.tips.sector"
                }, null, 8, ["modelValue", "needs-refresh", "remote-method"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('supporters.signup.form.fields.locations'),
              prop: "supporter.locations"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PxRadioGroup, {
                  modelValue: _ctx.hasSpecificLocations,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hasSpecificLocations) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElRadio, { value: true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("supporters.signup.form.locationOptions.specific")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ElRadio, { value: false }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("supporters.signup.form.locationOptions.all")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _withDirectives(_createVNode(_component_MultiSelector, {
                  modelValue: _ctx.form.data.supporter.locations,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.data.supporter.locations) = $event)),
                  "needs-refresh": _ctx.resetForm,
                  "no-label": true,
                  "remote-method": _ctx.searchLocations,
                  "subtext-label-list": [
                'common.components.multiSelector.locations.subLabel',
                'common.components.multiSelector.locations.subLabelPlural',
              ],
                  "validate-event": true,
                  class: "locations-selector",
                  "input-icon": "location",
                  placeholder: "supporters.signup.form.placeholders.locations",
                  tip: "supporters.signup.form.tips.location",
                  onChange: _ctx.formValidateLocations
                }, null, 8, ["modelValue", "needs-refresh", "remote-method", "onChange"]), [
                  [_vShow, _ctx.hasSpecificLocations]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ], 512), [
          [_vShow, _ctx.currentView !== 'general']
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "onValidate"])
  ]))
}